import { gql, useMutation, useQuery } from "@apollo/client";
import Select from "react-select";
import React, { useState } from "react";
import { Loading } from "../../../../../components/Loading";
import { Graphql } from "../../../../../graphql/_graphql";
import { OfferEditPanel } from "../panel/OfferEditPanel";
import { TableField } from "./TableField";
import { TableHeader } from "./TableHeader";
import { Toast } from "src/hooks/toast";
import { ProductUploadExcel } from "./ProductUploadExcel";
import { confirmService } from "src/hooks/confirmHook";
import { Pagination } from "src/components/pagination";

interface Props {
  status: "APPROVED" | "DRAFTING" | "REJECT";
}

const MERCHANT_BRAND_LIST = gql`
  query merchantBrandList($status: Int = 1) {
    merchantBrandList(status: $status) {
      id
      alias
      name
      banner
      picture
      description
      status
    }
  }
`;

const SUPPLIER_VENDOR_LIST = gql`
  query supplierVendorList {
    supplierVendorList {
      id
      name
      contactInfo
      address
      note
      margin
    }
  }
`;

const MUTATION_REMOTE = gql`
  mutation setSupplierMassRemoteStock($remoteStock: Boolean!) {
    setSupplierMassRemoteStock(remoteStock: $remoteStock)
  }
`;

const QUERY = gql`
  query supplierTagSuggestList {
    supplierTagSuggestList
  }
`;

function SelectTags({ tags, setTags }: { tags: any[]; setTags: any }) {
  const { data } = useQuery(QUERY);

  return (
    <label style={{ width: 250, marginLeft: 15 }}>
      <Select
        isMulti
        classNamePrefix="form-control"
        value={tags}
        options={
          data === undefined
            ? []
            : data.supplierTagSuggestList?.map((x: any) => {
                return { value: x.tag, label: x.tag };
              })
        }
        onChange={(e: any) => setTags(e ? e : [])}
        placeholder="Select Tags"
      />
    </label>
  );
}

export function ProductList(props: Props | any) {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [type, setType] = useState("AVAILABLE");
  const [sort, setSort] = useState("INPUTDATE");
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [item, setItem] = useState<any>(null);
  const [order, setOrder] = useState<"ASC" | "DESC" | any>("DESC");
  const [stocked, setStocked] = useState(false);
  const [brandSelect, setBrandSelect] = useState<{ value: number; label: string }[]>([]);
  const [vendorSelect, setVendorSelect] = useState<{ value: number; label: string }[]>([]);
  const [tagSelect, setTagSelect] = useState<{ value: number; label: string }[]>([]);

  const [setSupplierMassRemoteStock] = useMutation(MUTATION_REMOTE, {
    refetchQueries: ["supplierProductRequestList"],
    onCompleted: (res) => {
      if (res.setSupplierMassRemoteStock) {
        Toast.onShow("mass all product remote stock", "success", "right");
      }
    },
  });

  const brand = useQuery(MERCHANT_BRAND_LIST);
  const vendor = useQuery(SUPPLIER_VENDOR_LIST);
  const { data, loading, error } = useQuery(Graphql.Query.QUERY_SUPPLIER_REQUEST_LIST, {
    fetchPolicy: "no-cache",
    variables: {
      offset: offset * Number(limit),
      limit: Number(limit),
      filter: {
        status: props.status,
        type,
        search,
        order,
        sort,
      },
      brand: brandSelect.length === 0 ? undefined : brandSelect.map((x) => Number(x.value)),
      vendor: vendorSelect.length === 0 ? undefined : vendorSelect.map((x) => Number(x.value)),
      tags: tagSelect.map((x) => x.value),
    },
    onCompleted: (res) => {
      if (res.supplierProductRequestList.data.length === 0) {
        Toast.onShow("No data load...", "info", "right");
        // setOffset(0);
      }
    },
  });

  if (error) {
    return (
      <div className="table-responsive">
        <div className="alert alert-danger">Page are under maintenance!</div>
      </div>
    );
  }

  if (loading || data === undefined) {
    return (
      <div className="table-responsive">
        <table className="table table-padded">
          <TableHeader status={props.status} />
          <tbody>
            <tr>
              <td colSpan={13}>
                <Loading />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div>
      {item !== null && <OfferEditPanel item={item} onClickCancel={() => setItem(null)} />}
      <div className="row">
        <div className="col-sm-12 col-md-9">
          <div className="dataTables_length">
            {props.status === "APPROVED" && (
              <label style={{ marginRight: 30 }}>
                Filter
                <select
                  className="form-control form-control-sm"
                  style={{ width: 150 }}
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                >
                  <option value={"AVAILABLE"}>Available</option>
                  <option value={"DISCONTINUE"}>Discontinue</option>
                  <option value={"OUT_OF_STOCK"}>Out Of Stock</option>
                  <option value={"DISCOUNT_OFFER"}>Discount Offer</option>
                </select>
              </label>
            )}
            <label>
              Sort
              {props.status === "APPROVED" && (
                <select
                  className="form-control form-control-sm"
                  style={{ width: 100 }}
                  value={sort}
                  onChange={(e) => setSort(e.target.value)}
                >
                  <option value="INPUTDATE">Date</option>
                  <option value="STOCK">Stock</option>
                  <option value="SALE">Sale</option>
                </select>
              )}
              <select
                className="form-control form-control-sm"
                style={{ width: 100 }}
                value={order}
                onChange={(e) => setOrder(e.target.value)}
              >
                <option value="ASC">A - Z</option>
                <option value="DESC">Z - A</option>
              </select>
            </label>
            {props.status === "APPROVED" && (
              <>
                <label>
                  {/* <ProductListCSV
                    instock={stocked}
                    filter={{
                      status: props.status,
                      type,
                      search,
                      order,
                    }}
                    brand={brandSelect.length === 0 ? undefined : brandSelect.map((x) => Number(x.value))}
                    vendor={vendorSelect.length === 0 ? undefined : vendorSelect.map((x) => Number(x.value))}
                  /> */}
                </label>
                <label>
                  <ProductUploadExcel />
                </label>
              </>
            )}
            <label className="ml-3">
              <div className="form-check">
                <label className="form-check-label">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={stocked}
                    onChange={(e) => setStocked(e.target.checked)}
                  />{" "}
                  In stock
                </label>
              </div>
            </label>
          </div>
        </div>
        <div className="col-sm-12 col-md-3 text-right">
          <div className="dataTables_filter">
            <label>
              Search:
              <input
                type="text"
                className="form-control form-control-sm"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyDown={(e) => e.keyCode === 13 && setSearch(searchInput)}
              />
            </label>
          </div>
        </div>
        {props.status === "APPROVED" && (
          <div className="col-md-12">
            <hr />
            <div className="dataTables_length">
              <button
                className="btn btn-success btn-sm"
                onClick={async () => {
                  const result = await confirmService.show({
                    message: "Are sure you want enable all remote stock?",
                  });

                  if (result) {
                    setSupplierMassRemoteStock({
                      variables: { remoteStock: true },
                    });
                  }
                }}
              >
                Mass enable remote stock
              </button>
              <button
                className="btn btn-danger btn-sm"
                onClick={async () => {
                  const result = await confirmService.show({
                    message: "Are sure you want disabled all remote stock?",
                  });

                  if (result) {
                    setSupplierMassRemoteStock({
                      variables: { remoteStock: false },
                    });
                  }
                }}
              >
                Mass disabled remote stock
              </button>
              <label style={{ width: 250, marginLeft: 15 }}>
                <Select
                  isMulti
                  classNamePrefix="form-control"
                  value={brandSelect}
                  options={
                    brand.data === undefined
                      ? []
                      : brand.data.merchantBrandList?.map((x: any) => {
                          return { value: x.id, label: x.name };
                        })
                  }
                  onChange={(e: any) => setBrandSelect(e ? e : [])}
                  placeholder="Select Brand"
                />
              </label>
              <label style={{ width: 250, marginLeft: 15 }}>
                <Select
                  isMulti
                  classNamePrefix="form-control"
                  value={vendorSelect}
                  options={
                    vendor.data === undefined
                      ? []
                      : vendor.data.supplierVendorList?.map((x: any) => {
                          return { value: x.id, label: x.name };
                        })
                  }
                  onChange={(e: any) => setVendorSelect(e ? e : [])}
                  placeholder="Select Vendor"
                />
              </label>
              <SelectTags tags={tagSelect} setTags={setTagSelect} />
            </div>
            <hr />
          </div>
        )}
      </div>
      <Pagination
        props={props}
        offset={offset}
        setOffset={setOffset}
        total={data.supplierProductRequestList?.page?.total}
        limit={limit}
        setLimit={setLimit}
      />
      <br />
      <div>
        <table className="table table-padded">
          <TableHeader status={props.status} />
          <tbody>
            {stocked
              ? data.supplierProductRequestList.data
                  .filter((x: any) => x.content.stock > 0)
                  .map((x: any, i: number) => (
                    <TableField
                      key={i + Number(offset) * limit}
                      index={i + Number(offset) * limit}
                      status={props.status}
                      item={x}
                      type={type}
                      onItem={(e) => {
                        setItem(e);
                      }}
                    />
                  ))
              : data.supplierProductRequestList.data.map((x: any, i: number) => (
                  <TableField
                    key={i + Number(offset) * limit}
                    index={i + Number(offset) * limit}
                    status={props.status}
                    item={x}
                    type={type}
                    onItem={(e) => setItem(e)}
                  />
                ))}
          </tbody>
        </table>
      </div>
      <Pagination
        props={props}
        offset={offset}
        setOffset={setOffset}
        total={data.supplierProductRequestList?.page?.total}
        limit={limit}
        setLimit={setLimit}
      />
    </div>
  );
}
